module.exports = __webpack_public_path__ + "static/banner-footer-update-data-co-MB-eb7abb52f51360666397b692590f37c4.jpg";